import { Component, inject, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCloudArrowUp, faFile, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FileService } from '../../../services/file/file.service';

type FileCustom = {
  name: string;
  size: number | string;
  error: boolean;
};

@Component({
  selector: 'app-input-file',
  templateUrl: './input-file.component.html',
  styleUrls: ['./input-file.component.scss'],
  standalone: true,
  imports: [FaIconComponent],
})
export class InputFileComponent {
  private fileService = inject(FileService);

  faFile = faFile;
  faTrashCan = faTrashCan;
  faCloudArrowUp = faCloudArrowUp;
  uploadFileList: FileCustom[] = [];

  multiple: InputSignal<boolean> = input(false);
  accept: InputSignal<string[]> = input<string[]>([]);
  disabled: InputSignal<boolean> = input(false);
  withoutCompress: InputSignal<boolean> = input(false);

  uploadFileListChange: OutputEmitterRef<string[]> = output<string[]>();
  uploadFileListDelete: OutputEmitterRef<number> = output<number>();

  /*Supprimer un input file d'un tableau */
  inputDeleted: OutputEmitterRef<number> = output<number>();

  constructor() {}

  onFileChange(event: Event) {
    const target = event.target as HTMLInputElement;
    const files = target.files as FileList;
    this.uploadFileList = [];
    for (let index = 0; index < files.length; index++) {
      this.fileService
        .onFileChange(files[index], this.accept(), this.withoutCompress())
        .then((result) => {
          this.uploadFileList.push({ name: files[index].name, size: this.convertFileSize(files[index].size), error: false });
          this.uploadFileListChange.emit(result);
        })
        .catch((error) => {
          this.uploadFileList.push({ name: files[index].name, size: this.convertFileSize(files[index].size), error: true });
        });
    }
  }

  deleteFile(index: number) {
    if (this.uploadFileList[index] && !this.uploadFileList[index].error) {
      this.uploadFileListDelete.emit(index);
    }
    this.uploadFileList.splice(index, 1);
    this.inputDeleted.emit(index);
  }

  convertFileSize(oldFileSize: number) {
    if (oldFileSize < 1024) {
      return oldFileSize + ' octets';
    } else if (oldFileSize < 1024 * 1024) {
      return (oldFileSize / 1024).toFixed(2) + ' Ko';
    } else if (oldFileSize < 1024 * 1024 * 1024) {
      return (oldFileSize / (1024 * 1024)).toFixed(2) + ' Mo';
    } else {
      return (oldFileSize / (1024 * 1024 * 1024)).toFixed(2) + ' Go';
    }
  }
}
